import { createContext, useContext, useState } from "react";

const FormContext = createContext({ isFormValid: false, setIsFormValid: () => {} });

export const FormProvider = ({ children }) => {
  const [isFormValid, setIsFormValid] = useState(false);
  return (
    <FormContext.Provider value={{ isFormValid, setIsFormValid }}>
      {children}
    </FormContext.Provider>
  );
};

export const useFormContext = () => useContext(FormContext);
